import * as cx from 'classnames';
import Breadcrumb from 'mk/bazaar/common/components/Breadcrumb';
import * as React from 'react';
import styles from './BreadcrumbSiteStructure.mscss';

interface OwnProps {
    className?: string;
    items: React.ReactNode[];
}

export class BreadcrumbSiteStructure extends React.Component<OwnProps> {

    public render() {
        const { className, items } = this.props;

        return (
            <Breadcrumb
                className={cx(styles.BreadcrumbSiteStructure, className)}
                separator={(
                    <i className={cx(styles.BreadcrumbSiteStructure__separator, 'fa', 'fa-angle-right')} />
                )}
                items={items}
            />
        );
    }
}
